/**
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Organization api models
  Date: April 2020
**/

import { action, thunk } from 'easy-peasy';
import * as orgService from '../../services/organization';

const orgModel = {
  organizationId: '',
  setOrgsID: action((state, payload) => {
    state.organizationId = payload;
  }),

  addedOrganizationId: '',
  setAddedOrganizationId: action((state, payload) => {
    state.addedOrganizationId = payload;
  }),

  orgsData: {},
  setOrgs: action((state, payload) => {
    state.orgsData = payload;
  }),
  getOrgs: thunk(async (actions, payload) => {
    return await orgService
      .getOrgs(payload)
      .then(function (response) {
        actions.setOrgs(response.data.data);
        return response.data.data;
      })
      .catch(function (error) {
        actions.setOrgs({});
      });
  }),

  orgsList: [],
  setOrgsList: action((state, payload) => {
    state.orgsList = payload;
  }),
  orgsListLoader: false,
  setOrgsListLoader: action((state, payload) => {
    state.orgsListLoader = payload;
  }),
  getOrgsList: thunk(async (actions, payload) => {
    await orgService
      .getOrgsList(payload)
      .then(function (response) {
        actions.setOrgsListLoader(false);
        actions.setOrgsList(response.data.data.items);
      })
      .catch(function (error) {
        actions.setOrgsListLoader(false);
        actions.setOrgsList([]);
      });
  }),
  addOrgs: thunk(async (actions, payload) => {
    return await orgService.addOrgs(payload);
  }),
  updateOrgs: thunk(async (actions, payload) => {
    return await orgService.updateOrgs(payload);
  }),
  addProdcutToOrgs: thunk(async (actions, payload) => {
    return await orgService.addProductToOrg(payload);
  }),
  updateProdcutToOrgs: thunk(async (actions, payload) => {
    return await orgService.updateProductToOrg(payload);
  }),
  updateTenantStatus: thunk(async (actions, payload) => {
    return await orgService.updateTenantStatus(payload);
  }),

};

export default orgModel;
